const loginWithFacebook = ({ authentication, connectWithFacebook, onConnect, onError }) => {
  return () => {
    const { FB } = window;

    FB.login(
      auth => {
        if (auth.status === 'connected') {
          FB.api('/me', me => {
            const params = {
              uid: me.id,
              accessToken: auth.authResponse.accessToken,
            };
            connectWithFacebook(params, authentication)
              .then(onConnect)
              .catch(onError);
          });
        }
      },
      {
        scope: 'public_profile,email',
      }
    );
  };
};

export default loginWithFacebook;



// WEBPACK FOOTER //
// ./src/lib/login-with-facebook.js